import { useDeleteConfirmationDialog } from '@mews-commander/ui';
import { Typography } from '@optimus-web/core';
import { lt } from '@mews/framework';
import { useDeleteServiceProduct } from '../queries/LocalProductsTable';

interface Props {
    productIds: string[];
    currentEnterpriseId?: string;
    onSuccess?: () => void;
}

export const useDeleteServiceProductDialog = ({ productIds, currentEnterpriseId, onSuccess }: Props) => {
    const { mutateAsync, isPending } = useDeleteServiceProduct(currentEnterpriseId, onSuccess);

    const { confirmationDialog, openConfirmationDialog } = useDeleteConfirmationDialog({
        deleteAction: async () => mutateAsync({ productIds }),
        renderContent: () => (
            <Typography textStyle="bodyMedium" as="div">
                {lt('ServiceProductDeleteDialogContent')}
            </Typography>
        ),
        title: lt('ServiceProductDeleteDialogTitle'),
        loading: isPending,
    });

    return { confirmationDialog, openConfirmationDialog };
};
